import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

class DateFilter extends Component {
  // Syntax for taxonomy queries: http://dev-jba.colorcrate.com/wp-json/wp/v2/resource?page=1&resourceType=5,6
  constructor(props) {
    super(props);
    this.state = {
      selectOptions: null,
      selectedOption: null,
    };
  };

  componentDidMount() {
    let selectOptions = [];
    let selectedOption = null;
    for (let i=0; i<this.props.date.length; i++) {
      selectOptions.push(this.props.date[i]);
      if (this.props.date[i].active === true) {
        selectedOption = this.props.date[i];
      }
    }
    this.setState({
      selectOptions: selectOptions,
      selectedOption: selectedOption,
    });
  }

   componentDidUpdate() {
    // See if there's a new selected option, and if so apply it
    let selectedOption = this.state.selectedOption;
    let newSelectedOption = null;
    for (let i=0; i<this.props.date.length; i++) {
      if (this.props.date[i].active === true) {
        newSelectedOption = this.props.date[i];
      }
      selectedOption = newSelectedOption;
    }

    if (selectedOption !== this.state.selectedOption) {
      this.setState({
        selectedOption: selectedOption,
      });
    }
  };

  handleChange = (selectedOption) => {
    if (selectedOption !== null) {
      this.setState({
        selectedOption: selectedOption,
      }, function(){
        // Callback to send to Archive.js to apply the filter
        this.props.applyFilter({
          action: 'activate',
          obj: selectedOption,
        });
      });
    }
    else { // Null was passed, so deativate the selected option
      this.props.applyFilter({
        action: 'deactivate',
        obj: this.state.selectedOption,
      });
      this.setState({
        selectedOption: selectedOption,
      });
    }
  };

  render() {
    return (
      <div className="Sidebar__filter">
        <label htmlFor='date'>Date Range</label>
        <Select
          placeholder='All time'
          name='date'
          value={this.state.selectedOption}
          onChange={this.handleChange}
          options={this.props.date}
        />
      </div>
    );
  };
};
DateFilter.propTypes = {
  applyFilter: PropTypes.func,
  date: PropTypes.array,
  query: PropTypes.object,
};

export default DateFilter;


// WEBPACK FOOTER //
// ./src/components/filters/DateFilter.js